import {Snackbar, IconButton} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import {Alert} from '@material-ui/lab';
import {useRef} from 'react';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    alert: {
        color: `${theme.palette.type === 'dark' ? 'black' : 'white'}`,
    },
}));

const MCSSnackbar = ({
    open,
    onClose,
    message,
    severity = 'info',
    variant = 'filled',
    duration = 6000,
}) => {
    const domRef = useRef(null);
    const classes = useStyles();
    return (
        <Snackbar
            open={open}
            autoHideDuration={duration}
            onClose={onClose}
            ref={domRef}
        >
            <Alert
                severity={severity}
                elevation={6}
                variant={variant}
                className={classes.alert}
            >
                <div style={{display: 'flex', gap: '1em'}}>
                    <div style={{flexGrow: '1'}}>{message}</div>
                    <div>
                        <IconButton
                            size='small'
                            aria-label='close'
                            color='inherit'
                            onClick={onClose}
                        >
                            <Close fontSize='small' />
                        </IconButton>
                    </div>
                </div>
            </Alert>
        </Snackbar>
    );
};

export default MCSSnackbar;
